module.exports = __webpack_public_path__ + "static/media/denver-mobile.e6924c0d.webp";